require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import { InertiaProgress } from '@inertiajs/progress';

const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => require(`./Pages/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin)
            .mixin({ methods: { route } })
            .mount(el);
    },
});

InertiaProgress.init({ color: '#4B5563' });

// ServiceWorker
window.addEventListener('load', () => {
    if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js').
        then(() => {
            console.log('ServiceWorker registered')
        }).
        catch((error) => {
            console.warn('ServiceWorker error', error)
        })
    }
})
